module.exports = __webpack_public_path__ + "img/l3.d4c57210.png";